import styled from "styled-components";

export const BgHeader = styled.section`
  background-repeat: no-repeat;
  background-size: cover;
  height: 25vh;
`;
export const ContentHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 50px;
`;

export const ParentImgHeader = styled.div`
  position: sticky;
  bottom: 40px;
  right: 50%;
  display: flex;
  justify-content: center;
  height: 100%;
  align-items: end;
  z-index: 120;
`;

export const Container = styled.div`
  background-color: #fff;
  border-radius: 16px 16px 0px 0px;
  margin-top: -30px;

  padding: 40px 24px;
  margin-bottom: 0px;
  @media (max-width: 327px) {
    padding: 40px 16px;
  }
`;

export const InformationTitle = styled.h1`
  color: #4495b2;
  font-size: 20px;
  font-weight: 700;
  text-align: center;
  margin: 15px 0px 10px;
`;

//////////////////////////////////////////////
export const FormWrapper = styled.div``;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin: 15px 0px;
`;
export const Lable = styled.label`
  color: #2a3e64;
  font-size: 14px;
  font-weight: 600;
`;

export const Requierd = styled.span``;

export const InputField = styled.input`
  margin: 2px 0px;
  padding: 12px;
  border-radius: 7px;
  border: 1px solid #dde5ed;
  direction: ${(props) => (props.dir ? "ltr" : "rtl")};
`;

export const ErrorMessage = styled.span`
  color: red;
  font-size: 12px;
`;
